import Game from '../../../Game';
import BasePopupHandler from '../Menu/BasePopupHandler';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import GameObject from '../../../GameObject/GameObject';
import BaseUISystem from '../BaseUISystem';
import { PopupID } from '../../../State/UI/PopupID';

export default class MoreLevelsComingHandler extends BasePopupHandler {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.MORE_LEVELS_COMING, uiSystem);
    }

    protected createPopup(params?: unknown): void {
        this.underlayParams.cacheKey = 'no_ads_back';
        this.submitBtnParams.text.textLocalizationKey = 'Great';

        super.createPopup({
            buttons: [this.closeBtnParams, this.submitBtnParams],
            underlay: this.underlayParams,
            title: 'MoreLevels',
        });

        const description: GameObject<PIXI.Container> = UIItem.createText(
            this.descriptionParams
        );
        this.background.addChild(description);
    }

    protected descriptionParams: ITextData = {
        name: 'description',
        textLocalizationKey: 'ComingSoon',
        layout: {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            ...Game.style.getStyle('popup.green_btn'),
            fontSize: 55,
        },
    };
}
